import { getInitialState, getEndState, startQuery, accEvents, reflectSpan } from './reducer-utils'
import { BoxplotState, BoxplotEvent } from './types'

export const boxplotReducer: WidgetReducerType<BoxplotState, FlowMessage<LiveEvent<BoxplotEvent>>> = (
    state = getInitialState(),
    action
) => {
    switch (action?.type) {
        case 'start':
            return startQuery(action, state)

        case 'event':
            return accEvents(action, state)

        case 'endHistory':
            return getEndState(state)

        // case 'span':
        // return reflectSpan(action, state)

        default:
            return state
    }
}
